import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-113" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-114" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="👀 Découvrez ce que contiennent vos futurs supports de cours !" body="Feuilletez un aperçu des ressources pédagogiques incluses dans votre bibliothèque." data-id="element-115" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-116" data-mp="238q9ywqzi6u0">
          <InsidePagesCarousel data-id="element-117" data-mp="1y7amky1c3o8g" />
        </div>

        <p className="mx-auto mt-8 max-w-xl text-center text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-118" data-mp="1y82k4eehrw1d">
          Et ce n’est qu’un aperçu de votre système pédagogique complet !
        </p>
        <p className="mt-2 text-center font-body text-[13px] italic text-brand-charcoal/55" data-id="element-119" data-mp="3sjha8wbezxhn">
          Pages réelles du Volume 2 — touchez une page pour l’agrandir
        </p>
      </div>
    </section>;
}